import { Strategy } from '~/api-services/AIStrategyBuilderService/types';

// Hands the tapped list row to the detail screen so its header shows the right identity from the
// first frame, WITHOUT routing the object through navigation params — those serialize into the URL
// (`?preview=[object Object]`) and come back as a useless string on reload. A single id-matched
// slot is enough: the user opens one strategy at a time, and a cold load / deep link simply finds
// nothing here and falls back to the loading skeleton.
let slot: Strategy | null = null;

export const setStrategyPreview = (strategy: Strategy): void => {
    slot = strategy;
};

export const getStrategyPreview = (id: string): Strategy | null => (slot && slot.id === id ? slot : null);
